import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=04ed1625&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=ts"
export * from "./ChatBox.vue?vue&type=script&lang=ts"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=04ed1625&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed1625",
  null
  
)

export default component.exports